import React from "react";
import { Box, keyframes } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@ui/layout/Header";
import Footer from "@ui/layout/Footer";
import { colors } from "@theme/tokens";
import ScrollToTop from "@ui/atoms/AtomScrollToTop";

// CSS animation for page transitions - works on iOS Safari
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

function PublicLayout() {
  const location = useLocation();

  return (
    <Box position="relative" bg={colors.background.darkPrimary} w="100%" minH="100vh" display="flex" flexDir="column" overflowX="hidden">
      <ScrollToTop />

      {/* Header */}
      <Box position="sticky" top={0} zIndex={100}>
        <Header />
      </Box>

      {/* Main content - uses CSS animation instead of framer-motion */}
      <Box
        as="main"
        position="relative"
        zIndex={1}
        key={location.pathname}
        animation={`${fadeIn} 0.3s ease-out forwards`}
        sx={{ "@media (prefers-reduced-motion: reduce)": { animation: "none" } }}
        flex="1"
      >
        <Outlet />
      </Box>

      {/* Footer */}
      <Box position="relative" zIndex={1} mt="auto">
        <Footer />
      </Box>
    </Box>
  );
}

export default PublicLayout;
